// Module
var code = `<div class="hc-item-wrapper-check"
        ng-repeat="check in \$ctrl.checks" 
        ng-class="check.status === 'OK'? 'ok' : 'fail'"
        ng-if="!\$ctrl.hideOk || check.status === 'FAILED'">
  <div class="hc-item-wrapper-header">
    <div><strong>Name:</strong> <span>{{ check.name }}</span></div>
    <div><strong>Description:</strong> <span>{{ check.description }}</span></div>
    <div><strong>Statement:</strong> <span>{{ check.statement }}</span></div>
    <div><strong>Status:</strong> <span class="status" ng-class="check.status === 'FAILED' ? 'fail' : 'ok'">{{ check.status }}</span></div>
  </div>
  <div class="hc-item-wrapper-body" ng-if="check.details && check.details.length > 0">
    <strong>Details: </strong>
    <table class="hc-item-table">
      <tr ng-repeat="detail in check.details | max:10">
        <td>
          {{ detail }}
        </td>
      </tr>
      <tr ng-if="check.details.length > 10">
        <td>...{{ check.details.length - 10 }} more</td>
      </tr>
    </table>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/health-check-list/general-health-check/general-health-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;